import { render, staticRenderFns } from "./create_user.vue?vue&type=template&id=45ca9034&scoped=true"
import script from "./create_user.vue?vue&type=script&lang=js"
export * from "./create_user.vue?vue&type=script&lang=js"
import style0 from "./create_user.vue?vue&type=style&index=0&id=45ca9034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ca9034",
  null
  
)

export default component.exports